<div class="container-fluid px-3" *ngIf="showMainContent">
  <app-list-users />
</div>
<router-outlet></router-outlet>
